import React from 'react'
import { DeletionBannerProps } from './_props'
import TokTokDocDialog from '../Dialog'
import DeletionBannerDefaultContent from './DeletionBannerDefaultContent'
import DeletionSection from './DeletionSection'

const DeletionBanner = ({
    marginTop,
    buttonText,
    onConfirm,
    isPending,
    confirmationDialogContent,
    bannerTitle = 'Suppression',
    bannerLabel,
    bannerSubLabel,
    buttonName = 'Supprimer',
}: DeletionBannerProps) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const wasPendingRef = React.useRef(false)

    React.useEffect(() => {
        if (wasPendingRef.current && !isPending) {
            setIsOpen(false)
        }
        wasPendingRef.current = isPending ?? false
    }, [isPending])

    const handleClose = () => {
        if (!isPending) {
            setIsOpen(false)
        }
    }

    return (
        <>
            <DeletionSection
                marginTop={marginTop}
                buttonText={buttonText}
                bannerLabel={bannerLabel}
                bannerSubLabel={bannerSubLabel}
                onConfirm={() => setIsOpen(true)}
            />
            <TokTokDocDialog
                isOpen={isOpen}
                handleClose={handleClose}
                handleSave={onConfirm}
                loading={isPending}
                saveTitle={buttonName}
                title={bannerTitle}
                subtitle={bannerSubLabel}
                isDeleteAction
                disableEscape
            >
                {confirmationDialogContent ?? <DeletionBannerDefaultContent />}
            </TokTokDocDialog>
        </>
    )
}

export default DeletionBanner
